import React, { Component } from "react";
import {
  Layout,
  Menu,
  Row,
  Col,
  Button,
  Search,
  Typography,
  Dropdown,
  Space,
  Popover,
} from "antd";

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import {
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  MenuOutlined,
  HeartTwoTone,
  MessageOutlined,
} from "@ant-design/icons";
const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;

const { Title, Text } = Typography;
export default class navbar extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = { isAuthenticated: false, currentLocation: "", current: "" };
  }
  componentDidMount() {
    console.log(this.props.user);
    this.setState({
      isAuthenticated: this.props.isAuthenticated,
      currentLocation: window.location.pathname,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      this.setState({
        isAuthenticated: nextProps.isAuthenticated,
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  showHeader(location) {
    const login = (
      <Button>
        <Link to="/login">Login</Link>
      </Button>
    );

    const logout = (
      <Button onClick={this.props.logout}>
        Logout{" "}
        {!this.props.loading && this.props.user
          ? this.props.user.displayName
          : ""}
      </Button>
    );
    const authButton = this.state.isAuthenticated ? (
      <Col flex="100px">
        {logout}

        <Popover
          content={
            <p>
              If you need technical support, please contact Alan at
              alan@hanyc.org.
            </p>
          }
          title="Support"
        >
          <span type="secondary" style={{ marginLeft: "10px", color: "white" }}>
            <QuestionCircleOutlined /> Need Help?
          </span>
        </Popover>
      </Col>
    ) : (
      <Col flex="100px">{login}</Col>
    );

    const onClick = (value) => {
      this.setState({ current: value.key });
    };
    const items = [
      {
        key: "0",
        label: "BIG APPLE STARS AWARDS NOMINATION",
      },
      {
        key: "1",
        label: "Nominations",
        children: [
          {
            key: "1.1",
            label: <Link to="/member/nominations">My Nominations</Link>,
          },
          {
            key: "1.2",
            label: <Link to="/member/nomination/add"> Add Nomination</Link>,
          },
        ],
      },
      {
        key: "2",
        label: "Profile",
        children: [
          {
            key: "2.1",
            label: <Link to="/member/profile">My Profile</Link>,
          },
          {
            key: "2.2",
            label: <Link to="/member/profile/hotel">Update Hotel</Link>,
          },
        ],
      },
    ];
    const dropDownMenu = (items) => {
      return (
        <Header className="member-layout-header-mobile">
          <Dropdown
            className="member-layout-header-dropdown"
            menu={{
              // remove the first items
              items: items.slice(1),
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <MenuOutlined style={{ fontSize: "25px", color: "white" }} />
                <Text style={{ color: "white" }}>BIG APPLE STARS AWARDS</Text>
              </Space>
            </a>
          </Dropdown>
        </Header>
      );
    };

    return (
      <>
        {dropDownMenu(items)}
        <Header className="member-layout-header">
          <div style={{ flex: 1 }}>
            <Menu
              theme="dark"
              onClick={onClick}
              selectedKeys={[this.state.current]}
              mode="horizontal"
              items={items}
            />
          </div>

          <div style={{ flex: 1, textAlign: "right" }}>{authButton} </div>
        </Header>
      </>
    );
    // this.setState({ currentLocation: window.location.pathname });
    if (window.location.pathname.includes("admin")) {
      return null;
    }
    if (window.location.pathname.includes("judge")) {
      return null;
    }
    if (!this.state.isAuthenticated) {
      return (
        <Header
          className="header"
          style={{
            position: "fixed",
            zIndex: 1,
            width: "100%",
            backgroundColor: "transparent",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              alignContent: "center",
              paddingTop: "5px",
            }}
          >
            <Link to="/login">
              <img src="/hanyc_logo.png" width={"180px"} />
            </Link>
          </div>

          <Title level={4}>BIG APPLE STARS AWARDS NOMINATION</Title>

          {/* <Col flex="100px">{logout}</Col> */}
        </Header>
      );
    } else {
      switch (location) {
        case "/login":
          return (
            <Header
              className="header"
              style={{
                position: "fixed",
                zIndex: 1,
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  alignContent: "center",
                  paddingTop: "5px",
                }}
              >
                <Link to="/">
                  <img src="/hanyc_logo.png" width={"180px"} />
                </Link>
              </div>
              <Title level={4}>BIG APPLE STARS AWARDS NOMINATION</Title>
              {/* <Col flex="100px">{logout}</Col> */}
            </Header>
          );
        case "/register":
          return (
            <Header
              className="header"
              style={{
                position: "fixed",
                zIndex: 1,
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  alignContent: "center",
                  paddingTop: "5px",
                }}
              >
                <img src="/hanyc_logo.png" width={"180px"} />
              </div>
              <Title level={4}>BIG APPLE STARS AWARDS NOMINATION</Title>
              {/* <Col flex="100px">{logout}</Col> */}
            </Header>
          );
        default:
          return (
            <Header
              className="header"
              style={{ position: "fixed", zIndex: 1, width: "100%" }}
            >
              <div
                style={{
                  display: "flex",
                  alignContent: "space-around",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Menu theme="dark" mode="horizontal">
                    <Menu.Item key="0">
                      <Link
                        to="/"
                        onClick={() => {
                          window.location = "/";
                        }}
                      >
                        BIG APPLE STARS AWARDS NOMINATION
                      </Link>
                    </Menu.Item>
                    <SubMenu
                      key="SubMenu"
                      icon={<AppstoreOutlined />}
                      title="Nominations"
                    >
                      <Menu.Item key="1">
                        <Link to="/member/nominations">My Nominations</Link>
                      </Menu.Item>
                      <Menu.Item key="2">
                        <Link to="/member/nomination/add">Add Nomination</Link>
                      </Menu.Item>
                    </SubMenu>
                    <Menu.Item key="3">
                      <Link to="/member/profile">Profile</Link>
                    </Menu.Item>
                  </Menu>
                </div>

                <div style={{ flex: 1, textAlign: "right" }}>{authButton}</div>
              </div>

              {/* <Col flex="100px">{logout}</Col> */}
            </Header>
          );
      }
    }
  }

  render() {
    return this.showHeader(window.location.pathname);
  }
}
